export default new Promise((res) => {
    const script = document.createElement('script');
    script.onload = () => res();
    script.setAttribute('src', 'https://js.chargebee.com/v2/chargebee.js');
    script.setAttribute('data-cb-site', 'neo-networks');
    document.head.appendChild(script);
});